import { Base, Code, Password, Email, Number, Search, Tel, Url, TextArea } from "./inputFactory";
import { AutocompleteInput as Autocomplete } from "./AutocompleteInput";
import { EnvironmentVariableInput as EnvironmentVariable } from "./EnvironmentVariableInput";
import { DynamicTokenInput as DynamicToken, DynamicEmailInput as DynamicEmail } from "./DynamicInput";

export const TextInput = {
  Autocomplete,
  Base,
  Code,
  DynamicEmail,
  DynamicToken,
  Password,
  Email,
  EnvironmentVariable,
  Number,
  Search,
  Tel,
  Url,
  TextArea,
};
